<template>
    <!-- Error dialog -->
    <v-dialog modal max-width="800" v-model="show">
        <v-toolbar color="">
            <v-toolbar-title>Errors</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="close">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card>
            <v-card-text>
                <v-list>
                    <v-list-item v-for="(error,index) in data" :key="index">
                        <v-list-item-action>
                            <v-icon color="red" class="mr-2">mdi-alert-circle-outline</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            {{ error }}
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-btn color="primary" @click="close">Close</v-btn>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

    export default {

        props: ['data'],

        data() {
            return {
                show: true
            }
        },
        methods: {
            close() {
                this.$emit('close');
            }
        }
    }
</script>